// loadComponent comunica con la libreria npm che abbiamo installato, qui stiamo importando McElement che in sostanza estende HTMLElement (lo trovi nella sezione test)
// tutti i componenti che ti servono vanno chiamati così, con /components/nome-componente.js se sono su npm, li trovi tutti nella tab Componenti in sezione test
await loadComponent('./components/mc-element.js', false);

// queste sono le uniche librerie che hanno "res" invece che "components", le ho messe qua solo per farti vedere come si importano
await loadComponent('./res/mc-utils.js', false); // la trovi documentata sulla tab McUtils nella sezione test
await loadComponent('./res/mc-events.js', false); // la trovi documentata sulla tab Eventi nella sezione test
await loadComponent('./res/mc-shopify.js', false); // la trovi documentata sulla tab McShopify nella sezione test

class VariantSelectorMobile extends McElement {
  
  connectedCallback() {
    window.addEventListener('mobile-open-selector', e => {
        this.open();
        this.render(e.detail.url);
    });

    window.addEventListener('cart:updated', () => {
        const offCanvas = bootstrap.Offcanvas.getInstance(this);
        if(offCanvas){
          offCanvas.hide();
        }
    });

    this.btnVariant();
  }

  //metodo per aprire l'offcanvas
  open = () => {
    const offCanvas = bootstrap.Offcanvas.getOrCreateInstance(this);

    if(!offCanvas){
      console.error('ComposeroffCanvas: l\'elemento deve essere un offCanvas');
      return;
    }

    offCanvas.show();
  }
    
  //metodo per renderizzare la collection uando le section rendering api
  render = (url) => {

    // deve essere presente un elemento con data-body altrimenti non funziona
    const body = this.querySelector('[data-body]');
    if(!body){
      console.error('ComposerModal: elemento data-body mancante');
      return;
    }

    // chiamiamo l'html della collezione con le section rendering api e inseriamo il contenuto nel body del modal
    McShopify.section({
      path: url,
      section_id: 'helper-variant-selector-mobile',
      onSuccess: response => {
        body.innerHTML = response;
        
        setTimeout(() => {
          const cartAddButtons = body.querySelectorAll('cart-add');
          cartAddButtons.forEach(button => {
            button.addEventListener('click', () => {
        
              setTimeout(() => {
                const offCanvas = bootstrap.Offcanvas.getInstance(this);
                if (offCanvas) {
                  offCanvas.hide();
                }
              }, 500); 
            });
          });
        }, 100);
        
        // Reinizializza Measmerize dopo aver caricato il contenuto
        setTimeout(() => {
          const measmerizeBtn = document.getElementById('measmerize-button');
          if (measmerizeBtn && window.Measmerize) {
            console.log('Reinitializing Measmerize for mobile variant selector');
            window.Measmerize.init();
          }
        }, 500);
      }
    });
  }

  //evento per aggiunta del prodotto a carrello
  btnVariant() {
    const root = this;
    root.querySelectorAll('.variant-option').forEach(button => {
      button.addEventListener('click', () => {
        const variantId = button.dataset.variantId;

        if (!variantId) {
          console.warn('[VariantSelectorMobile] variantId mancante');
          return;
        }

        button.classList.add('loading');
        button.disabled = true;

        McShopify.addToCart({
          items: [
            {
              id: parseInt(variantId),
              quantity: 1
            }
          ],
          onSuccess: (data) => {
            window.dispatchEvent(new CustomEvent('cart:updated'));
            root.dispatchEvent(new CustomEvent('variant:added', { detail: data }));
            
            const offCanvas = bootstrap.Offcanvas.getOrCreateInstance(root);
            if(offCanvas){
              offCanvas.hide();
            }
          },
          onError: (error) => {
            console.error('[VariantSelectorMobile] Errore:', error);
            alert('Errore durante l\'aggiunta al carrello');
          },
          onComplete: () => {
            button.classList.remove('loading');
            button.disabled = false;
          }
        });
      });
    });
  }
}

if (!customElements.get('variant-selector-mobile')) {
  customElements.define('variant-selector-mobile', VariantSelectorMobile);
}

window.VariantSelectorMobile = VariantSelectorMobile;